document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('colorselector');
  if (!root) return;

  var currentSlug = (window.location.pathname || '').split('/products/')[1] || '';
  currentSlug = currentSlug.split('/')[0] || currentSlug;

  var collectionTitle = '';
  try {
    collectionTitle = (window.meta && window.meta.product && window.meta.product.filter_collection) ? window.meta.product.filter_collection : '';
  } catch(e) {}

  var metafieldEl = document.querySelector('[data-filter-collection]');
  if (metafieldEl && metafieldEl.getAttribute('data-filter-collection')) {
    collectionTitle = metafieldEl.getAttribute('data-filter-collection');
  }

  if (!collectionTitle) return;

  var productCollections = Array.prototype.slice.call(document.querySelectorAll('[data-product-collection-title]'));
  var collectionHandle = '';
  for (var i = 0; i < productCollections.length; i++) {
    if (productCollections[i].getAttribute('data-product-collection-title') === collectionTitle) {
      collectionHandle = productCollections[i].getAttribute('data-product-collection-handle') || '';
      break;
    }
  }
  if (!collectionHandle) return;

  fetch('/collections/' + collectionHandle + '/?view=filter-color', { credentials: 'same-origin' })
    .then(function (r) { return r.text(); })
    .then(function (txt) {
      var last = txt.charAt(txt.length - 2);
      var jsonText = (last === ',') ? ('[' + txt.slice(0, -2) + ']') : ('[' + txt + ']');
      var data = JSON.parse(jsonText);

      root.innerHTML = '<label>Color</label><select onchange="this.options[this.selectedIndex].value && (window.location = this.options[this.selectedIndex].value);"></select>';
      var select = root.querySelector('select');
      if (!select) return;

      var productName = '';
      for (var j = 0; j < data.length; j++) {
        if (data[j] && typeof data[j][0] !== 'undefined') {
          productName = data[j][0];
          break;
        }
      }

      for (var k = 0; k < data.length; k++) {
        var v = data[k];
        if (!v || typeof v.handle === 'undefined') continue;
        if (typeof v.media === 'undefined') continue;

        var current = (currentSlug === v.handle) ? 'selected' : '';
        var color = (productName ? String(v.title).replace(productName, '') : String(v.title));
        color = color.replace('-', '').trim();
        if (!color) continue;

        var opt = document.createElement('option');
        opt.value = '/products/' + v.handle;
        opt.textContent = color;
        if (current) opt.selected = true;
        select.appendChild(opt);
      }
    });
});
